var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_51_828",
    transform: "matrix(0.0588235 0 0 0.0470588 0 -0.0176471)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_51_828",
    width: 17,
    height: 22,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAWCAYAAAAmaHdCAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEfSURBVHgBrVMxTsUwDH0hKSDaDyxQVWLgBFyBiXtwBQ7BzBUYuAYTB6FDIUgwgBoJRJpv7CqVENNvzZOs51TRi/3sGvKrSwA3HIfYDG0f0vXZxfFd27bffF4b8vuPAJ1iBlJC707686qqnkIIb26ugMBarJxzByyw5uPHFhZiGAah7aZp7GKRDGOtJa0Iuq4zi0XYEyHidqD1BN57XTtFUQgZjQjFGKFqRyrgSgy3A42xUglJrjHWTLl62f5DBCoR9sTkEZPDQrAnYqqEbu1lxJKLyDtm4vOLXoRlxNOyXXFF7aYCQ0K4f0i3uZ1YlmWaZi1iRxwNxl9iLFOWaTQvL9V0lzJHjmeO19+PyKXduq5L5jFyvpfP1Z/vO/lx/AD/h2gnyniM9gAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCard);
export default __webpack_public_path__ + "static/media/yellow-card.9f826ecd18fa7577c5e7b3982e23ba03.svg";
export { ForwardRef as ReactComponent };